<template>
  <div class="form-field">
    <div class="form-field__meta">
      <div>
        <a-form-label
          v-if="label"
          :for="labelType !== 'p' && id"
          :id="labelId"
          :type="labelType"
        >
          <span v-html="label" />
        </a-form-label>

        <a-form-help-button
          v-if="help"
          :aria-controls="helpId"
          :aria-expanded="showHelp ? 'true' : 'false'"
          @click="showHelp = !showHelp"
        />

        <a-form-help
          v-if="help"
          v-show="showHelp"
          :aria-hidden="showHelp ? 'false' : 'true'"
          :id="helpId"
        >
          {{ help }}
        </a-form-help>
      </div>

      <span
        v-if="maxLength"
        :class="{ 'form-field__input-length--error': valueLength > maxLength }"
        class="form-field__input-length"
      >
        <i>{{ valueLength }} / {{ maxLength }}</i>
      </span>
    </div>

    <div class="form-field__input">

      <slot :describedby="describedby" />

      <p
        v-if="labelAfter"
        :id="labelAfterId"
        class="form-input__label-after"
      >
        {{ labelAfter }}
      </p>
    </div>

    <div
      v-if="hasError"
      :id="errorId"
    >
      <a-form-error
        v-for="(error, index) in errors"
        v-if="error.show"
        :key="index"
      >
        {{ error.message }}
      </a-form-error>
    </div>

    <i
      v-for="(validationHint, index) in validationHints"
      :key="index"
    >
      {{ validationHint }}
    </i>

  </div>
</template>

<script>
import AFormError from '@/components/form/atoms/AFormError'
import AFormHelp from '@/components/form/atoms/AFormHelp'
import AFormHelpButton from '@/components/form/atoms/AFormHelpButton'
import AFormLabel from '@/components/form/atoms/AFormLabel'

export default {
  name: 'AFormField',

  components: {
    AFormError,
    AFormHelp,
    AFormHelpButton,
    AFormLabel
  },

  props: {
    id: {
      type: String,
      required: true
    },
    length: {
      type: Number,
      default: 0
    },
    label: {
      type: String
    },
    labelAfter: {
      type: String
    },
    labelType: {
      type: String
    },
    help: {
      type: String
    },
    hasError: {
      type: Boolean
    },
    errors: {
      type: Array
    },
    maxLength: {
      type: Number,
      default: 0
    },
    valueLength: {
      type: Number,
      default: 0
    },
    validationHints: {
      type: Array,
      default: () => []
    }
  },

  data () {
    return {
      showHelp: false
    }
  },

  computed: {
    labelId () {
      return this.id + '-label'
    },
    errorId () {
      return this.id + '-error'
    },
    helpId () {
      return this.id + '-help'
    },
    labelAfterId () {
      return this.id + '-label-after'
    },
    describedby () {
      let labels = []

      if (this.labelAfter) {
        labels.push(this.labelAfterId)
      }

      if (this.help) {
        labels.push(this.helpId)
      }

      if (this.hasError) {
        labels.push(this.errorId)
      }

      if (labels.length) {
        return labels.join(' ')
      }
    }
  }
}
</script>

<style scoped>
.form-field {
  margin-bottom: 24px;
}

.form-field__meta {
  display: flex;
  flex-direction: column;

  gap: 1rem;
  justify-content: space-between;
}

@media (min-width: 900px) {
  .form-field__meta {
    flex-direction: row;
    gap: 2.5rem;
  }
}

.form-field__input {
  display: flex;
  align-items: center;
}

.form-field__input-length {
  min-width: max-content;
  align-self: end;
}

.form-field__input-length--error {
  color: var(--color-error);
}
</style>
